import React, { useState, useEffect, useContext } from "react";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ChemistDashboard = () => {
  const [medicineOrders, setMedicineOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    setSessionTimeout,
    setAlert,
    setMessage,
  } = useContext(languageContext);

  const navigate = useNavigate();
  

  const getMedicineOrders = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/chemist_request",
        {},
        { headers: headersList }
      );
      if (response.status === 200) {
        setMedicineOrders(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const getMedicineOrdersSearch = async (value) => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/chemist_request",
        { search: value },
        { headers: headersList }
      );
      if (response.status === 200) {
        setMedicineOrders(response.data?.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response?.data?.detail === "Token has expired") {
      setSessionTimeout(true);
    } else {
      console.error("Error Details:", error.message);
      setAlert(true);
      setMessage("Please try again later, something went wrong");
    }
  };

  useEffect(() => {
    const init = async () => {
      const currentPagePath = window.location.pathname;
      const loginBool = localStorage.getItem("login");

      if (loginBool === "true") {
        navigate("/chemist_dashboard", { state: { url: currentPagePath } });
        await getMedicineOrders();
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    };

    init();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getMedicineOrdersSearch(searchTerm.trim());
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-green-50 to-green-100 p-6">
      <h1 className="text-3xl font-bold text-green-800 mb-6 text-center">
        Chemist Dashboard – Medicine Orders
      </h1>
      <div className="flex justify-center mb-8">
        <input
          type="text"
          placeholder="Search by patient number, UID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full max-w-md px-4 py-2 rounded-lg border border-green-300 focus:outline-none focus:ring-2 focus:ring-green-400"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {medicineOrders.length === 0 ? (
          <div className="col-span-full text-center text-gray-600">
            No medicine orders found.
          </div>
        ) : (
          medicineOrders.map((order) => (
            <div
              key={order.id}
              className="bg-white rounded-2xl shadow-md border border-green-200 p-5"
            >
              <h2 className="text-xl font-semibold text-green-700 mb-2">
                {order.medicine_name}
              </h2>
              <p className="text-gray-600 text-sm">
                Patient Number: {order.patient_number}
              </p>
              <p className="text-gray-600 text-sm">
                UID: {order.uid}
              </p>
              <p className="text-gray-600 text-sm">
                Quantity: {order.quantity}
              </p>
              <p className="text-gray-600 text-sm">
                Address: {order.address}
              </p>
              <p className="text-gray-600 text-sm">
                Delivery Date: {order.delivery_date}
              </p>
              {/* <p className="text-gray-600 text-sm">
                Delivered:{" "}
                <span
                  className={
                    order.delivered ? "text-green-600 font-semibold" : "text-red-600 font-semibold"
                  }
                >
                  {order.delivered}
                </span>
              </p> */}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ChemistDashboard;
